import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ChartModule } from 'angular-highcharts';

import { AppRoutingModule } from './app-routing.module';

import { MatSliderModule } from '@angular/material/slider';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';


import { AppComponent } from './app.component';
import { LoginComponent } from './modules/login/login.component';
import { AdminPortalComponent } from './modules/admin-portal/admin-portal.component';
import { PublisherPortalComponent } from './modules/publisher-portal/publisher-portal.component';
import { HeaderComponent } from './layout/header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { HttpClientModule } from '@angular/common/http';

import {MatMenuModule} from '@angular/material/menu';
import {MatSelectModule} from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { ResetPasswordComponent } from './modules/reset-password/reset-password.component';
import { AppSharedModule } from './shared/app-shared/app-shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MessageBoxComponent } from './modules/message-box/message-box.component';
import { ToastrModule } from 'ngx-toastr';
import { ForgetPasswordComponent } from './modules/forget-password/forget-password.component';
import { NgxUiLoaderModule, NgxUiLoaderConfig } from 'ngx-ui-loader';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#2B2C36',
  fastFadeOut: true,
  minTime: 0
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ResetPasswordComponent,
    MessageBoxComponent,
    ForgetPasswordComponent,  
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    MatInputModule,
    ChartModule,
    MatTableModule,
    MatDatepickerModule,
    HttpClientModule,
    MatMenuModule,
    MatSelectModule,
    AppSharedModule,
    ModalModule,
    ToastrModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
  ],
  exports:[MatMenuModule],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
